import React from 'react'
import cx from 'classnames'

import styles from './Item.module.scss'

type ItemProps = React.LiHTMLAttributes<HTMLLIElement>

export const Item = React.forwardRef<HTMLLIElement, ItemProps>(
  ({ children, className, ...restProps }, ref) => (
    <li className={cx(styles.item, className)} {...restProps} {...{ ref }}>
      {children}
    </li>
  ),
)

Item.displayName = 'List.Item'
